import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/cta-1-element-1.svg")